module.exports = __webpack_public_path__ + "static/media/testimonial-3.4de8cc59.jpg";